
import React from 'react';
import { Product } from '../../../types';
import { Coffee, ArrowUpRight, ShoppingBag, Plus, Zap } from 'lucide-react';
import { StoreImage } from '../../ui/StoreImage';

interface CardProps {
  product: Product & { boostAmount?: number };
  onAddToCart: (product: Product) => void;
}

export const CardBrutal: React.FC<CardProps> = ({ product, onAddToCart }) => {
  const hasVariants = product.variants && product.variants.length > 0;
  
  let displayPrice = product.price;
  if (hasVariants) {
      const prices = product.variants!.map(v => v.price);
      displayPrice = Math.min(...prices);
  }

  const displayImage = product.images?.[0] || product.imageUrl;

  return (
    <div 
        onClick={() => onAddToCart(product)} 
        className="group bg-white border-2 border-black p-0 h-full flex flex-col cursor-pointer shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] hover:translate-x-[2px] hover:translate-y-[2px] transition-all duration-100 active:shadow-none active:translate-x-[4px] active:translate-y-[4px]"
    >
        {/* Image Area with Border Bottom */}
        <div className="aspect-square w-full border-b-2 border-black overflow-hidden relative bg-stone-100">
            {displayImage ? (
                <StoreImage
                    src={displayImage}
                    width={640}
                    alt={product.name} 
                    className="w-full h-full object-cover filter grayscale group-hover:grayscale-0 transition-all duration-300" 
                />
            ) : (
                <div className="w-full h-full flex items-center justify-center text-black"><Coffee size={40} strokeWidth={2.5}/></div>
            )}
            
            <div className="absolute top-0 right-0 bg-black text-white px-3 py-1.5 text-xs font-black font-mono border-l-2 border-b-2 border-white">
                {displayPrice} KR
            </div>

            {/* Boost Badge */}
            {product.boostAmount && product.boostAmount > 0 && (
                <div className="absolute top-0 left-0 bg-yellow-400 text-black px-2 py-1.5 text-[10px] font-black uppercase font-mono border-r-2 border-b-2 border-black flex items-center gap-1">
                    <Zap size={10} fill="currentColor" strokeWidth={2.5} />
                    +{product.boostAmount}KR
                </div>
            )}
        </div>

        {/* Content Area */}
        <div className="p-4 flex-1 flex flex-col justify-between">
            <div className="mb-4">
                <h3 className="text-base md:text-lg font-black uppercase text-black leading-none mb-2 break-words tracking-tight">
                    {product.name}
                </h3>
                <p className="text-xs font-mono font-medium text-stone-600 line-clamp-2 leading-tight">
                    {product.description}
                </p>
            </div>
            
            <div className="flex items-center justify-between pt-3 border-t-2 border-stone-100 group-hover:border-black transition-colors mt-auto">
                <span className={`text-[10px] font-black uppercase px-2 py-1 flex items-center gap-1.5 ${hasVariants ? 'bg-stone-200 text-black' : 'bg-yellow-400 text-black'}`}>
                    {hasVariants ? 'VÄLJ SORT' : <><Plus size={12} strokeWidth={3} /> LÄGG TILL</>}
                </span>
                <div className="bg-black text-white p-1">
                    <ArrowUpRight size={16} className="group-hover:rotate-45 transition-transform" />
                </div>
            </div>
        </div>
    </div>
  );
};
